import React from 'react';
import './StoryMedium.scss';
import { IImageData } from '../../../pages/Root/services/api/interfaces.ts';
import Image from '../../../components/Image/Image.tsx';
import PublisherLogo from '../PublisherLogo/PublisherLogo.tsx';
import { StorySize } from '../../types/story-types';
import TextParser from '../../../pages/Root/components/TextParser/TextParser.tsx';

interface StoryMediumProps {
  imageList: IImageData[];
  tags: string[];
  title: string;
  description: string;
  publisherLogo?: string;
  darkPublisherLogo?: string;
  publisherName?: string;
  hidePublisher: boolean;
  hideCategory: boolean;
}

const StoryMedium: React.FC<StoryMediumProps> = ({
  imageList,
  tags,
  title,
  description,
  publisherLogo,
  publisherName,
  darkPublisherLogo,
  hidePublisher = false,
  hideCategory = true,
}) => {
  return (
    <div className="story-medium">
      <div className="story-image-container">
        <Image
          withSkeleton
          className="story-image-med"
          imageContainerClassName="border-radius-sm"
          alt={title}
          imageList={imageList}
        ></Image>
      </div>
      {!hidePublisher && publisherLogo && (
        <PublisherLogo
          publisherLogo={publisherLogo}
          publisherName={publisherName ?? ''}
          storySize={StorySize.MEDIUM}
          darkPublisherLogo={darkPublisherLogo}
        />
      )}
      {!hidePublisher && !publisherLogo && publisherName && (
        <div className="story-publishername">{publisherName}</div>
      )}
      <h2 className="story-title">
        <TextParser
          text={title}
          option={{ isIgnoreLinks: true, removeHTML: true }}
        />
      </h2>
      <p className="story-description">
        <TextParser
          text={description}
          option={{ isIgnoreLinks: true, removeHTML: true }}
        />
      </p>
      {!hideCategory && tags?.length > 0 && (
        <div className="story-tags">
          {tags.map((tag, index) => {
            return (
              <span key={index} className="story-tag">
                {tag}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StoryMedium;
